import { SelectField } from '@origin-digital/style-guide';
import React from 'react';
import analytics from '../../../../analytics';

import { isFieldTouched } from '../../../../utils/formHelpers';

import { SelectFieldAdapterProps } from './SelectFieldAdapter.types';

export class SelectFieldAdapter extends React.Component<SelectFieldAdapterProps, {}> {
  constructor(props: SelectFieldAdapterProps) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (event: React.FormEvent<HTMLSelectElement>): void => {
    const { field, form, changeHandler } = this.props;

    form.setFieldValue(field.name, event.currentTarget.value);

    if (changeHandler) {
      changeHandler({ [field.name]: event.currentTarget.value });
    }

    analytics.dropdownSelect(field.name, event.currentTarget.value);
  };

  render(): JSX.Element {
    const { field, form, options, label } = this.props;

    return (
      <SelectField
        name={field.name}
        label={label}
        value={field.value}
        //@ts-ignore
        touched={isFieldTouched(form, field.name)}
        //@ts-ignore
        error={form.errors[field.name]}
        options={options}
        onBlur={field.onBlur}
        onChange={e => this.handleChange(e)}
      />
    );
  }
}

export { SelectFieldAdapter as default };
